/**
 * 空闲判定（纯函数）。
 *
 * 为什么触屏机必须有这个：
 *   上一位顾客点完就走了，屏幕停在他的购物车上。下一位顾客过来，
 *   看到的是别人的菜、别人的金额 —— 一不留神就用别人的购物车下了单，
 *   然后两个人为「这单是谁的」在收银台吵架。这是触屏机最常见的现场事故。
 *
 * 所以规则是：**没人碰屏幕一段时间 → 提醒 → 再没人碰 → 清空重来。**
 * 提醒这一步不能省：顾客可能正在看菜单思考，直接清空同样会被投诉。
 */

export type IdleAction =
  /** 一切正常，什么都不用做 */
  | 'none'
  /** 该提醒顾客「还在吗」了 */
  | 'warn'
  /** 该清空购物车回首页了 */
  | 'reset';

/**
 * @param secondsSinceTouch 距离最后一次触摸过去了多少秒
 * @param warnSeconds 多少秒后提醒
 * @param resetSeconds 提醒之后再等多少秒就清空
 */
export function evaluateIdle(
  secondsSinceTouch: number,
  warnSeconds: number,
  resetSeconds: number,
): IdleAction {
  if (secondsSinceTouch >= warnSeconds + resetSeconds) return 'reset';
  if (secondsSinceTouch >= warnSeconds) return 'warn';
  return 'none';
}

/**
 * 提醒弹窗里的倒计时。
 * 顾客碰一下屏幕就会重置整个空闲计时，所以这个倒计时只是「还会等多久」的展示。
 */
export function countdownSeconds(
  secondsSinceTouch: number,
  warnSeconds: number,
  resetSeconds: number,
): number {
  const left = warnSeconds + resetSeconds - secondsSinceTouch;
  return Math.max(0, Math.ceil(left));
}
